import { BIBLE_BOOKS } from './bibleBooks';

export const CANONICAL_BOOK_COUNT = 66;

function toDateString(value) {
  if (!value) return '';
  if (typeof value === 'string') return value.slice(0, 10);
  return '';
}

export function isDateInWindow(dateValue, startDate, endDate) {
  if (!startDate || !endDate) return false;
  const date = toDateString(dateValue);
  if (!date) return false;
  return date >= startDate.slice(0, 10) && date <= endDate.slice(0, 10);
}

/**
 * Count finished books (every chapter of the book has at least one report).
 * Denominator is always the 66-book Protestant canon.
 */
export function countFinishedBooks(chapters, chapterReadCounts = {}) {
  const byBook = new Map();

  for (const chapter of chapters) {
    const name = chapter.book;
    if (!byBook.has(name)) {
      byBook.set(name, { total: 0, read: 0 });
    }
    const group = byBook.get(name);
    group.total += 1;
    if ((chapterReadCounts[chapter.id] || 0) > 0) {
      group.read += 1;
    }
  }

  let finished = 0;
  for (const book of BIBLE_BOOKS) {
    const group = byBook.get(book.name);
    if (group && group.total > 0 && group.read >= group.total) {
      finished += 1;
    }
  }

  return { finished, total: CANONICAL_BOOK_COUNT };
}

/**
 * Reports in the challenge window. Each report is one chapter read.
 * Returns null when there is no window so the UI can show an em dash.
 */
export function countChaptersInWindow(reports, startDate, endDate) {
  if (!startDate || !endDate) return null;
  return reports.filter((report) =>
    isDateInWindow(report.readDate, startDate, endDate)
  ).length;
}

export function countUniqueChapters(reports) {
  return new Set(reports.map((report) => report.chapterId).filter(Boolean)).size;
}
